import { LOGIN } from '../constants';
import { instance, baseUrl } from '../../axios';
import { setUserAction, cleanUserAction } from '../actions/user';
import { cleanNotificationAction } from '../actions/notification';
import { cleanCompanyAction } from '../actions/company';
import { cleanStatsAction } from '../actions/stats';

// Public route
const loginAction = (data) => {
  return (dispatch) => {
    dispatch({
      type: LOGIN.LOGIN_REQUEST,
    });
    instance({
      method: 'POST',
      url: baseUrl + '/token',
      data: {
        email: data.email,
        password: data.password,
        type: 'web',
      },
    })
      .then((results) => {
        dispatch({
          type: LOGIN.LOGIN_SUCCESS,
          payload: results.data,
        });
        dispatch(setUserAction(results.data.User));
        dispatch(updateSelectedCompanyAction(results.data.User.Company));
      })
      .catch((error) => {
        dispatch({
          type: LOGIN.LOGIN_FAILURE,
          payload: error,
        });
      });
  };
};

const logoutAction = () => {
  return (dispatch) => {
    dispatch(cleanUserAction());
    dispatch(cleanNotificationAction());
    dispatch(cleanStatsAction());
    dispatch(cleanCompanyAction());
    dispatch({
      type: LOGIN.LOGOUT,
    });
  };
};

const updateSelectedCompanyAction = (company) => {
  return (dispatch) => {
    dispatch({
      type: LOGIN.UPDATE_SELECTED_COMPANY,
      payload: company,
    });
  };
};

const cleanError = () => {
  return (dispatch) => {
    dispatch({
      type: LOGIN.CLEAN_ERROR,
    });
  };
};

const validateAuthAction = () => {
  return (dispatch, getState) => {
    const { login, user } = getState();
    const { tokenAccess } = login;
    const { user: userData } = user;

    dispatch({
      type: LOGIN.VALIDATE_AUTH_REQUEST,
    });

    // If no token, validation fails
    if (!tokenAccess) {
      dispatch({
        type: LOGIN.VALIDATE_AUTH_FAILURE,
      });
      dispatch(logoutAction());
      return;
    }

    // If token exists but no user data, logout (shouldn't happen with persistence)
    if (!userData) {
      dispatch({
        type: LOGIN.VALIDATE_AUTH_FAILURE,
      });
      dispatch(logoutAction());
      return;
    }

    // Both token and user exist, validation succeeds
    dispatch({
      type: LOGIN.VALIDATE_AUTH_SUCCESS,
    });
  };
};

export { loginAction, logoutAction, cleanError, updateSelectedCompanyAction, validateAuthAction };
